<template>
  <ErrorScreen>
    <template v-slot:title> {{ $t("screens.maintenanceScreen.title") }} </template>
    <template v-slot:message> {{ $t("screens.maintenanceScreen.message") }} </template>
    <template v-slot:cta>
      <ButtonLink
        variant="primary"
        size="medium"
        to="https://status.signable.co.uk/incidents/h0msw13br5s2">
        {{ $t("screens.maintenanceScreen.ctaButton") }}
      </ButtonLink>
    </template>
  </ErrorScreen>
</template>
<script>
import { defineComponent } from 'vue';
import { ErrorScreen } from '@/components/screens/ErrorScreen';
import ButtonLink from '@/components/library/links/ButtonLink.vue';

export default defineComponent({
  name: 'MaintenanceScreen',
  components: {
    ErrorScreen,
    ButtonLink,
  },
});
</script>
